import React from 'react';
import { Access } from './../contexts/user'
import { DateTime } from 'luxon';

export const newDate = (value = '') => {
  var field = value.match(/^([+-]?\d{4}(?!\d\d\b))(?:-?(?:(0[1-9]|1[0-2])(?:-?([12]\d|0[1-9]|3[01]))?)(?:[T\s](?:(?:([01]\d|2[0-3])(?::?([0-5]\d))?|24\:?00)([.,]\d+(?!:))?)?(?::?([0-5]\d)(?:[.,](\d+))?)?([zZ]|([+-](?:[01]\d|2[0-3])):?([0-5]\d)?)?)?)?$/) || [];
  var result = new Date(field[1], field[2] - 1 | 0, field[3] || 1, field[4] | 0, field[5] | 0, field[7] | 0, field[8] | 0);
  result.setUTCMinutes(0 - result.getTimezoneOffset() - ((field[10] * 60 + +field[11]) || 0));

  // result.setMinutes( result.getMinutes() - 12 );
  return result;
};

export const formatPhoneNumber = (phoneNumberString: string) => {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
}

export const stringToDate = (dateString: string) => {
  if (!dateString) return new Date(NaN);

  // Luxon parsing is far more consistent across browsers than Date.parse.
  // We treat "date-only" strings as UTC start-of-day.
  const s = String(dateString).trim();
  const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(s);
  if (isDateOnly) {
    const dt = DateTime.fromISO(s, { zone: 'utc' }).startOf('day');
    return dt.isValid ? dt.toJSDate() : new Date(NaN);
  }

  const normalized = s.includes(' ') ? s.replace(' ', 'T') : s;
  // If the input includes an offset/Z, respect it. Otherwise assume UTC.
  const hasZone = /[zZ]$/.test(normalized) || /[+-]\d{2}:?\d{2}$/.test(normalized);
  const dt = DateTime.fromISO(normalized, hasZone ? { setZone: true } : { zone: 'utc' });
  return dt.isValid ? dt.toJSDate() : new Date(NaN);
}

export const formatDateString = (dateString: string, seconds?: boolean) => {
  const d = stringToDate(dateString);
  if (isNaN(d.getTime())) return '';
  const dt = DateTime.fromJSDate(d);
  return dt.toFormat(seconds ? 'MMM d, h:mm:ssa' : 'MMM d, h:mma');
};

export const formatMinutesOverdue = (minutes?: number | null) => {
  if (minutes === null || minutes === undefined) return '';
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const remainderMinutes = minutes % 60;
    return remainderMinutes ? `${hours}h ${remainderMinutes}m` : `${hours}h`;
  }
  const days = Math.floor(hours / 24);
  const remainderHours = hours % 24;
  return remainderHours ? `${days}d ${remainderHours}h` : `${days}d`;
};

export const numberWithCommas = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const getDashboardOptions = (role: Access) => {
  return [Access.ADMIN, Access.OWNER].indexOf(role) > -1 ? [
    { id: 'users', label: 'Users', value: 'users' },
    { id: 'account', label: 'Account', value: 'account' },
  ] : [
    { id: 'users', label: 'Users', value: 'users' },
    { id: 'account', label: 'Account', value: 'account' },
  ]
};
